import {
  Component,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  Input,
  style
} from "@angular/core";
import { ModalDirective } from "ng2-bootstrap/components/modal";
import { TranslateService } from "../../shared/translate/translate.service";
import { InstanceModel } from "../../instance/models/instance.model";
import {
  VatSettingsModel,
  VatDefaultModel
} from "../models/vat-settings.model";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";
import { WeGoConfig, IKeyValueInterface } from "../../shared/config";
import { FlatPickrDirective } from "../../plugins/flatpickr/flatpickr.directive";
const moment = require("moment");
@Component({
  selector: "wego-vat-setting",
  template: require('../views/vat-setting.component.html'),
  styles: [
    `
      .vatlineheight {
        line-height: 30px;
      }
      .margin-bottom {
        margin-bottom: 5px;
      }
    `
  ]
})
export class VatSettingsComponent implements OnInit {
  vatEndDate: string;
  vatEndDateValidationMessage: string;
  vatIndex: any;
  flatPickrConfigEndDate: FlatPickrModel;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;

  @ViewChild("flatPickrConfigEndDateDir")
  public flatPickrConfigEndDateDir: FlatPickrDirective;
  @ViewChild("vatSettingspopup") public vatSettingsPopup: any;
  @ViewChild("alertModal") public alertModal: any;
  @Input("VatSettingsList") vatSettingsList: Array<VatSettingsModel>;
  @Input("VatSettingDefaultCost") vatSettingDefaultCost: boolean;
  @Input("VatDefaultRate") vatDefaultRate: VatDefaultModel;
  @Input("ErrorModel") errorModel: IKeyValueInterface[];
  @Output("OnVatSetting") onVatSetting = new EventEmitter();

  ngOnInit(): void {
    this.flatPickrConfigEndDate = this.SetDefaultFlatPickrConfig();
  }

  constructor(private translate: TranslateService) {}

  public onVatConfirm($event: any) {
    let vatSettingsModel = new VatSettingsModel();
    vatSettingsModel.description = $event.vatDescription;
    vatSettingsModel.vat = $event.vatPercentage;
    vatSettingsModel.vatStartDate = $event.vatStartDate;
    this.vatSettingsList.push(vatSettingsModel);

    this.SetDefaultRate();

    this.onVatSetting.emit({
      vatSettingsList: this.vatSettingsList,
      vatSettingDefaultCost: this.vatSettingDefaultCost
    });
  }

  public SetDefaultRate() {
    this.vatDefaultRate.defaultVatDistanceRates =
      this.vatDefaultRate.defaultVatDistanceRates &&
      this.vatSettingsList.length > 0
        ? this.vatDefaultRate.defaultVatDistanceRates
        : this.vatSettingsList.length > 0
          ? this.vatSettingsList[0].vat
          : "";

    this.vatDefaultRate.defaultVatFixedRates =
      this.vatDefaultRate.defaultVatFixedRates &&
      this.vatSettingsList.length > 0
        ? this.vatDefaultRate.defaultVatFixedRates
        : this.vatSettingsList.length > 0
          ? this.vatSettingsList[0].vat
          : "";

    this.vatDefaultRate.defaultVatPenaltyCost =
      this.vatDefaultRate.defaultVatPenaltyCost &&
      this.vatSettingsList.length > 0
        ? this.vatDefaultRate.defaultVatPenaltyCost
        : this.vatSettingsList.length > 0
          ? this.vatSettingsList[0].vat
          : "";

    this.vatDefaultRate.defaultVatSubscriptionCost =
      this.vatDefaultRate.defaultVatSubscriptionCost &&
      this.vatSettingsList.length > 0
        ? this.vatDefaultRate.defaultVatSubscriptionCost
        : this.vatSettingsList.length > 0
          ? this.vatSettingsList[0].vat
          : "";

    this.vatDefaultRate.defaultVatTimeRates =
      this.vatDefaultRate.defaultVatTimeRates && this.vatSettingsList.length > 0
        ? this.vatDefaultRate.defaultVatTimeRates
        : this.vatSettingsList.length > 0
          ? this.vatSettingsList[0].vat
          : "";

    this.vatDefaultRate.defaultVatPeriodRates =
      this.vatDefaultRate.defaultVatPeriodRates && this.vatSettingsList.length > 0
        ? this.vatDefaultRate.defaultVatPeriodRates
        : this.vatSettingsList.length > 0
          ? this.vatSettingsList[0].vat
          : "";
  }

  public onChange(): void {
    this.onVatSetting.emit({
      vatSettingsList: this.vatSettingsList,
      vatSettingDefaultCost: this.vatSettingDefaultCost
    });
  }

  public ShowAlertModal(index: any) {
    if (this.vatSettingsList[index].vatSettingHashId) {
      let format = "DD-MM-YYYY";
      let newDate = moment(
        this.vatSettingsList[index].vatStartDate,
        format
      ).toDate();
      this.flatPickrConfigEndDateDir.SetOption("minDate", newDate);
      this.vatEndDateValidationMessage = "";
      this.vatIndex = index;
      this.alertModal.show();
    } else {
      this.vatSettingsList.splice(index, 1);
      this.SetDefaultRate();
    }
  }

  public SuccessAlertModalClick(): void {
    if (this.vatEndDate) {
      this.removeVatDetail(this.vatIndex);
      this.alertModal.hide();
    } else {
      this.vatEndDateValidationMessage = this.translate.instant(
        "LblVatEndDateError"
      );
    }
  }

  public removeVatDetail(index: any) {
    if (this.vatSettingsList[index].vatSettingHashId) {
      this.vatSettingsList[index].vatEndDate = this.vatEndDate;
    }
    this.vatIndex = null;
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public HideAlertModal(): void {
    this.alertModal.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vat-setting/component/vat-setting.component.ts